import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useEffect, useState, useCallback } from 'react';
import { getDocumentOptions } from '../utilities';
export var useCountdown = function useCountdown(date, options) {
  var _options$intervalTime = options.intervalTime,
      intervalTime = _options$intervalTime === void 0 ? 1000 : _options$intervalTime,
      _options$now = options.now,
      now = _options$now === void 0 ? function () {
    return Date.now();
  } : _options$now;

  var _getDocumentOptions = getDocumentOptions(),
      hidden = _getDocumentOptions.hidden,
      visibilityChangeEvent = _getDocumentOptions.visibilityChangeEvent; //@ts-ignore


  var _useState = useState(function () {
    return new Date(date()) - new Date(now());
  }),
      _useState2 = _slicedToArray(_useState, 2),
      timeLeft = _useState2[0],
      setTimeLeft = _useState2[1];

  var intervalRef = useRef();
  var isMountedRef = useRef(true);
  var timerClear = useCallback(function () {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = undefined;
    }
  }, []);
  var timerStart = useCallback(function (interval) {
    timerClear();
    intervalRef.current = setInterval(function () {
      if (!isMountedRef.current) {
        timerClear();
        return;
      }

      setTimeLeft(function (current) {
        if (current <= 0) {
          timerClear();
          return 0;
        }

        return current - intervalTime;
      });
    }, interval);
  }, [intervalTime, timerClear]);
  var reset = useCallback(function () {
    timerClear();

    if (isMountedRef.current) {
      //@ts-ignore
      setTimeLeft(function () {
        return new Date(date()) - new Date(now());
      });
      timerStart(intervalTime);
    }
  }, [date, intervalTime, now, timerStart, timerClear]);
  var handleVisibilityChangeEvent = useCallback(function () {
    if (!document[hidden] && isMountedRef.current) {
      reset();
    }
  }, [hidden, reset]);
  useEffect(function () {
    reset();
  }, [reset]);
  useEffect(function () {
    isMountedRef.current = true;
    timerStart(intervalTime);
    document.addEventListener(visibilityChangeEvent, handleVisibilityChangeEvent);
    return function () {
      isMountedRef.current = false;
      timerClear();
      document.removeEventListener(visibilityChangeEvent, handleVisibilityChangeEvent);
    };
  }, [intervalTime, timerStart, handleVisibilityChangeEvent, timerClear]);
  return {
    timeLeft: timeLeft
  };
};